import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnPullToRefresh as UICnPullToRefresh } from './pull-to-refresh';
import './styles/index.scss';
const CnPullToRefresh = withI18n(UICnPullToRefresh, {
    locale,
    _noHoc: true,
});
export { CnPullToRefresh };
